import Rails from '@rails/ujs';
import { getHtmlFromAjaxResponse } from './ajaxResponseHelpers';

export default class ActionAssignation {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    $(".action-assignation-btn").on('click', this.showActionAssignationModal);
    $("#action-assignation-modal-save").on('click', this.saveActionAssignation);
  }

  showActionAssignationModal() {
    const url = $(this).data('url');

    Rails.ajax({
      url: url,
      type: 'GET',
      success: function(response, _status, xhr) {
        $("#action-assignation-modal-body").html(getHtmlFromAjaxResponse(response, xhr));
        $("#action-assignation-modal").modal('show');
      }
    });
  }

  saveActionAssignation() {
    let form = $("#action-assignation-form");
    

    Rails.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function(data) {
        $("#action-assignation-modal").modal('hide');
        var action_id = data.action_id;
        console.log(data);

        $("#" + action_id + "-assigned-to").html(data.assigned_to)
        application.successNotification(I18n.t('backoffice.actions.assignation_success'));
      }
    });
  }

  onDataChanged(data) {
  }

  onDestroy() {
    $(".action-assignation-btn").off('click', this.showActionAssignationModal);
    $("#action-assignation-modal-save").off('click', this.saveActionAssignation);
  }
}